// StudentLayout — sidebar nav + shell for the student role (rendered by the shared AppShell).
import AppShell, { type NavItem } from "./AppShell.js";

const NAV_ITEMS: readonly NavItem[] = [
  { to: "/app/student",              label: "Dashboard",    end: true },
  { to: "/app/student/courses",      label: "Courses",      end: false },
  { to: "/app/student/attendance",   label: "Attendance",   end: false },
  { to: "/app/student/payments",     label: "Payments",     end: false },
  { to: "/app/student/certificates", label: "Certificates", end: false },
  { to: "/app/student/profile",      label: "Profile",      end: false },
];

export default function StudentLayout() {
  return <AppShell title="Student" items={NAV_ITEMS} />;
}
